enum CompaniesTableType {
  Agencies = 'agencies',
  Companies = 'companies',
  CorporateCompanies = 'corporate-companies',
}

export default CompaniesTableType;
